import React, { useRef } from 'react';
import {
  MenuTrigger as AriaMenuTrigger,
  MenuTriggerProps,
} from 'react-aria-components';

import classNames from 'classnames';
import * as styles from './Menu.module.scss';

type Props = {
  children: React.ReactNode;
  onMenuOpenChange?: (isOpen: boolean) => void;
  className?: string;
} & MenuTriggerProps;

const attachAriaModalAttribute = (elementRef: React.RefObject<any>) => {
  // Waits for popover element to be rendered
  setTimeout(() => {
    const button = elementRef.current?.querySelector('button');
    const buttonID = button?.id;

    if (!buttonID) return;

    const dialog = document.querySelector(`[aria-labelledby="${buttonID}"]`);

    if (dialog) {
      // Why? For the element with role="dialog" (Popover), we need aria-modal="true" to communicate the keyboard behavior properties.
      // Workaround: React Aria removes the `aria-modal` attribute, we use ref to apply it on render.
      dialog.setAttribute('aria-modal', 'true');
    }
  }, 0);
};

export const MenuTrigger = ({
  children,
  onMenuOpenChange,
  className,
  ...rest
}: Props) => {
  const menuTriggerRef = useRef<HTMLDivElement>(null);

  const handleOpenChange = (isOpen: boolean) => {
    onMenuOpenChange && onMenuOpenChange(isOpen);

    attachAriaModalAttribute(menuTriggerRef);
  };

  return (
    <div
      ref={menuTriggerRef}
      className={classNames(styles.MenuTrigger, className)}
    >
      <AriaMenuTrigger onOpenChange={handleOpenChange} {...rest}>
        {children}
      </AriaMenuTrigger>
    </div>
  );
};
